import { render, staticRenderFns } from "./landing-layout.vue?vue&type=template&id=0acc2739"
import script from "./landing-layout.vue?vue&type=script&lang=js"
export * from "./landing-layout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports